<template>
  <div
    class="header"
    :style="{ backgroundImage: `url(${item.display_img_url})` }"
  >
    <div class="header-content">
      <template v-if="isMember">
        <div class="use-time">到期时间：{{ card.card_expiry_date }}</div>
      </template>
      <template v-else>
        <div class="header-price">
          <span class="unit">¥</span>
          <span>{{ wxjkInfo.payment_amount }}</span>
        </div>
        <div class="header-time">购买后30天有效</div>
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

import { useStore } from "@/components/use/base";

export default defineComponent({
  props: ["item", "wxjkInfo", "card"],
  setup() {
    const store = useStore();

    const isMember = computed(() => store.state.isMember);

    return {
      isMember,
    };
  },
});
</script>

<style lang="less" scoped>
.header {
  height: 168px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: -32px;
  position: relative;

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 49px;
    right: 59px;
    top: 108px;

    .use-time {
      font-weight: 400;
      font-size: 12px;
      color: #b8aba4;
      line-height: 17px;
      margin-top: 10px;
    }

    .header-price {
      font-weight: 500;
      font-size: 20px;
      color: #c3b6ae;
      line-height: 32px;

      .unit {
        font-size: 12px;
        margin-right: 2px;
      }
    }

    .header-time {
      font-weight: 400;
      font-size: 12px;
      color: #c3b6ae;
      line-height: 17px;
    }
  }
}
</style>
